export const snackbarMessages = {
  'camp67-snackbar.invalid-date-range': 'The date range you selected is not valid.',
  'camp67-snackbar.invalid-bathing-dates-range':
    'Bookings with bathing dates must be at least 3 days and 2 nights in duration.',
  'camp67-snackbar.invalid-bathing-date-selected':
    'Bookings cannot start or end on a bathing date.',
};
